import { inject, Injectable } from '@angular/core';
import { filter, mergeMap, take } from 'rxjs/operators';
import { LogoutDialogComponent } from './logout-dialog.component';
import { BeginLogout } from '../../state/auth.actions';
import { Navigate } from '@ngxs/router-plugin';
import { Select, Store } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';
import { AuthState } from '../../state/auth.state';
import { AuthenticatedUser } from '../../state/auth.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LogoutService {

    private user$: Observable<AuthenticatedUser> = inject(Store).select(AuthState.user);

    constructor(
        private store: Store,
        private dialog: MatDialog
    ) { }

    doLogout() {
        this.user$
            .pipe(
                filter((user) => !!(user && user.username)),
                take(1),
                mergeMap(() => this.dialog.open(LogoutDialogComponent).afterClosed()),
                filter((b) => b),
                mergeMap(() => this.store.dispatch(new BeginLogout(true)))
            )
            .subscribe(() => {
                // explicitly do NOT keep query params on logout
                this.store.dispatch(new Navigate([ '/auth/login' ], null, { queryParamsHandling: '' }));
            });
    }
}
